// Identity's code is always six digits.
export const CODE_LENGTH = 6;
export const CODE_DIGITS = new RegExp(`^\\d{${CODE_LENGTH}}$`);

export const CODE_RESEND_SECONDS = 30;
